import axios from 'axios';
import i18n from '@/js/i18n';
import api from '@/services/api';

import { getUrlContext, getCurrentLanguage, inMgnl } from '@/helpers/AppHelpers';

export default {
  // Info des salles provenant du content App bingo
  MAJEUR: 'MAJEUR',
  RECENT: 'RECENT',

  getSalles(lang) {
    return axios
      .get(getUrlContext(process.env.VUE_APP_REST_JEL.replace('CONTENT_APP', 'bingoSalles')), {
        params: {
          lang: getCurrentLanguage(),
        },
      })
      .then((response) => {
        return response.data.results;
      });
  },

  // Info des salles provenant du service du fournisseur
  getSallesLive(lang) {
    if (inMgnl) {
      return {};
    }

    const headers = {
      'Content-Type': 'application/json',
    };

    return api
      .call('bingo-api/api/v1/salles', 'bingoSalles', 'GET', {
        headers,
        params: {
          lang,
          // Cache busting est la moitié du délai de raffaichissement (store/modules/bingo.js)
          _: Math.floor(
            new Date().getTime() / (process.env.NODE_ENV == 'production' ? 15000 : 5000)
          ), // 15 sec en PO, 5 sec en DEV
        },
      })
      .then((response) => {
        return this.mappingSalles(response.data.salles);
      });
  },

  // Info des Gagnants provenant du service du fournisseur
  // Type: MAJEUR|RECENT
  getGagnants(type) {
    if (inMgnl) {
      return {};
    }

    const headers = {
      'Content-Type': 'application/json',
    };

    const mockBingoGagnants = type === 'MAJEUR' ? 'bingoGagnantsMajeur' : 'bingoGagnantsRecent';

    return api
      .call('bingo-api/api/v1/gagnants', mockBingoGagnants, 'GET', {
        headers,
        params: {
          type,
        },
      })
      .then((response) => {
        return this.mappingGagnants(response.data);
      });
  },

  mappingGagnants(gagnants) {
    const listeGagnants = [];
    if (typeof gagnants === 'object') {
      // eslint-disable-next-line array-callback-return
      gagnants.map((gagnant) => {
        listeGagnants.push({
          gagnant: Array.of(gagnant.id, gagnant.gain, gagnant.idSalle, gagnant.dateGain),
        });
      });
    }
    return listeGagnants;
  },

  mappingSalles(salles) {
    if (typeof salles === 'object') {
      Object.entries(salles).forEach(([cle, salle]) => {
        salle.idSalle = `${cle}`;
        salle.nomSalle = salle.nom;
        salle.ouvert = salle.ouverte;
        salle.nomJeu = i18n.locale === 'en' ? salle.nomJeuEn : salle.nomJeuFr;
        salle.debutTirage = salle.dateDebutTirage;
        Object.entries(salle.grosLots).forEach(([cle, grosLot]) => {
          grosLot.id = `${cle}`;
          grosLot.nom = i18n.locale === 'en' ? grosLot.nomEn : grosLot.nomFr;
        });
      });
      return salles;
    }
    return {};
  },
};
